import { ChevronRightIcon } from '../Icon/ChevronRightIcon';
import { ChevronLeftIcon } from '../Icon/ChevronLeftIcon';
import { paginationSchema } from './Pagination.schema';
import { useFilterForm } from '~/hooks/useFilterForm';
import styles from './Pagination.module.css';

interface Props {
  count: number | undefined;
}

export function Pagination({ count }: Props) {
  const { setValue, values } = useFilterForm(paginationSchema.parse);

  const page = values.pageIndex;
  const size = values.pageSize;
  const total = count ?? 0;

  const from = page * size + 1 - size;
  const to = Math.min(page * size, total);

  const disablePrev = page <= 1;
  const disableNext = page * size >= total;

  function handlePrevious() {
    setValue('pageIndex', `${values.pageIndex - 1}`);
  }

  function handleNext() {
    setValue('pageIndex', `${values.pageIndex + 1}`);
  }

  return (
    <div className={styles.pagination}>
      <div>{`Visar ${from}-${to} av ${total}`}</div>

      <div className={styles.actions}>
        <button
          aria-label="Visa föregående sida"
          className={styles.arrow}
          onClick={handlePrevious}
          disabled={disablePrev}
        >
          <ChevronLeftIcon />
        </button>

        <button className={styles.arrow} disabled={disableNext} onClick={handleNext} aria-label="Visa nästa sida">
          <ChevronRightIcon />
        </button>
      </div>
    </div>
  );
}
